var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "position-relative" }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-toggle nav-link",
              attrs: {
                href: "#",
                id: "accountMenuList",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window",
              },
            },
            [
              _c("svg", { attrs: { width: "32", height: "32" } }, [
                _c("title", [_vm._v("Mein Konto")]),
                _vm._v(" "),
                _c("desc", [_vm._v("Benutzerkonto-Symbol")]),
                _vm._v(" "),
                _c("path", {
                  staticStyle: { fill: "#303239", "stroke-width": "0px" },
                  attrs: {
                    d: "M16.00058,16.99345c1.64697,0,3.29492-.59863,4.54883-1.7959,1.23047-1.1748,1.90771-2.73926,1.90771-4.40723,0-1.66699-.67725-3.23145-1.90771-4.40625-2.50781-2.39355-6.58887-2.39258-9.09766,0-1.23096,1.1748-1.90869,2.73926-1.90869,4.40625,0,1.66797.67773,3.23242,1.9082,4.40723,1.25439,1.19727,2.90137,1.7959,4.54932,1.7959ZM12.83261,7.83134c.87354-.83398,2.02051-1.25098,3.16797-1.25098,1.14697,0,2.29443.41699,3.16797,1.25098.83105.79297,1.28857,1.84375,1.28857,2.95898,0,1.11621-.45752,2.16699-1.28857,2.95996-1.74707,1.66797-4.58984,1.66797-6.33594,0-.83154-.79297-1.28955-1.84473-1.28955-2.95996,0-1.11426.45801-2.16602,1.28955-2.95898Z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticStyle: { fill: "#303239", "stroke-width": "0px" },
                  attrs: {
                    d: "M16.00058,17.84111c-5.52344,0-10.01709,3.84766-10.01709,8.57715v1h20.03271v-1c0-4.72949-4.49316-8.57715-10.01562-8.57715ZM8.07578,25.41826c.58936-3.15332,3.91846-5.57715,7.9248-5.57715,4.00537,0,7.33398,2.42383,7.92334,5.57715h-15.84814Z",
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-menu small m-0 p-0 mw-100" }, [
            _c(
              "div",
              {
                staticClass: "list-group",
                attrs: { "aria-labelledby": "accountMenuList" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "list-group-item small",
                    attrs: { href: _vm.$ceres.urls.myAccount },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-user",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [{ name: "logout", rawName: "v-logout" }],
                    staticClass: "list-group-item small",
                    attrs: { href: "#" },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-sign-out",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _vm.showLogin
            ? _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: {
                    "data-testing": "login-select",
                    href: _vm.isLogin ? "javascript:void(0)" : "#login",
                    "data-toggle": _vm.isLogin ? false : "modal",
                    "aria-label": _vm.$translate("Ceres::Template.login"),
                  },
                  on: {
                    click: function ($event) {
                      _vm.createLoginModal()
                      _vm.unmarkInputFields()
                    },
                  },
                },
                [
                  _c("svg", { attrs: { width: "32", height: "32" } }, [
                    _c("title", [_vm._v("Mein Konto")]),
                    _vm._v(" "),
                    _c("desc", [_vm._v("Benutzerkonto-Symbol")]),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { fill: "#303239", "stroke-width": "0px" },
                      attrs: {
                        d: "M16.00058,16.99345c1.64697,0,3.29492-.59863,4.54883-1.7959,1.23047-1.1748,1.90771-2.73926,1.90771-4.40723,0-1.66699-.67725-3.23145-1.90771-4.40625-2.50781-2.39355-6.58887-2.39258-9.09766,0-1.23096,1.1748-1.90869,2.73926-1.90869,4.40625,0,1.66797.67773,3.23242,1.9082,4.40723,1.25439,1.19727,2.90137,1.7959,4.54932,1.7959ZM12.83261,7.83134c.87354-.83398,2.02051-1.25098,3.16797-1.25098,1.14697,0,2.29443.41699,3.16797,1.25098.83105.79297,1.28857,1.84375,1.28857,2.95898,0,1.11621-.45752,2.16699-1.28857,2.95996-1.74707,1.66797-4.58984,1.66797-6.33594,0-.83154-.79297-1.28955-1.84473-1.28955-2.95996,0-1.11426.45801-2.16602,1.28955-2.95898Z",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { fill: "#303239", "stroke-width": "0px" },
                      attrs: {
                        d: "M16.00058,17.84111c-5.52344,0-10.01709,3.84766-10.01709,8.57715v1h20.03271v-1c0-4.72949-4.49316-8.57715-10.01562-8.57715ZM8.07578,25.41826c.58936-3.15332,3.91846-5.57715,7.9248-5.57715,4.00537,0,7.33398,2.42383,7.92334,5.57715h-15.84814Z",
                      },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }